import React from 'react';
import { CtaButton } from './CtaButton';
const guarantees = ['Natychmiastowy dostęp', 'Wersja do druku', '30-dniowa gwarancja'];
export function FinalCta() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-24" data-id="element-91" data-mp="19eyyx5dc8tyh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-92" data-mp="19ga4naqcgbs8">
        <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-93" data-mp="15cu7mdad49f0">
          Gotowy, by odmienić swoje{' '}
          <span className="italic text-brand" data-id="element-94" data-mp="1jasb2nn5alfq">lekcje plastyki?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-95" data-mp="1eds5edu7jkp5">
          Oszczędź czas na planowaniu i prowadź każdą lekcję z pełną pewnością
          siebie.
        </p>
        <CtaButton data-id="element-96" data-mp="1o4n1e9x99yns" />
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50" data-id="element-97" data-mp="1o67pbgp2ejco">
          {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-98" data-mp="1x6cudk6sd5no" data-mpi={index}>
              <span data-id="element-99" data-mp="n6e4lks7mfvu">{item}</span>
              {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-100" data-mp="s45s82ltnfu8">
                  ·
                </span>}
            </li>)}
        </ul>
      </div>
    </section>;
}